<template>
  <div class="unbill-container">
    <van-list
      v-if="unbilledList.length > 0"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了～"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getData"
    >
      <div
        v-for="(unbill, index) in unbilledList"
        :key="index"
        class="panel-box"
      >
        <div class="panel-head">
          <span class="head-left">
            <span class="head-title">{{ unbill.cutMonth | getMonth }}月</span>
            <span
              v-if="unbill.subAccountId"
              class="sub-title"
            >
              子账号：{{ unbill.subAccountId }}
            </span>
          </span>
          <span
            v-if="unbill.poiCount"
            class="head-right"
          >共{{ unbill.poiCount }}家门店</span>
        </div>
        <div class="menu-list">
          <div
            v-if="unbill.rentDivideAmount!=null"
            class="menu-item border1px-bottom"
            :data-bid="$BID.BILL_LIST_UNBILL_RENT"
            :data-cid="cid"
            @click="gotoPage(0, unbill)"
          >
            <span class="item-label">租宝分成</span>
            <span>
              <span>{{ unbill.rentDivideAmount | formatAmount }}元
                <i class="right-arrow"></i>
              </span>
            </span>
          </div>
          <div
            v-if="unbill.saleDivideAmount!=null"
            class="menu-item border1px-bottom"
            :data-bid="$BID.BILL_LIST_UNBILL_SALE"
            :data-cid="cid"
            @click="gotoPage(1, unbill)"
          >
            <span class="item-label">售宝分成</span>
            <span>{{ unbill.saleDivideAmount | formatAmount }}元
              <i class="right-arrow"></i>
            </span>
          </div>
          <div
            v-if="unbill.agentAgreementBillAmount"
            class="menu-item border1px-bottom"
            @click="gotoAgentActivity(unbill)"
          >
            <span class="item-label">活动账单</span>
            <span>{{ unbill.agentAgreementBillAmount | formatAmount }}元
              <i class="right-arrow"></i>
            </span>
          </div>
          <div
            v-if="unbill.overChargeAmount<0"
            class="menu-item border1px-bottom"
            @click="gotoPage(1, unbill, 'amortize')"
          >
            <span class="item-label">多宝摊销</span>
            <span>{{ unbill.overChargeAmount | formatAmount }}元
              <i class="right-arrow"></i>
            </span>
          </div>
          <div
            v-if="unbill.assetInventoryAddAmount>0"
            class="menu-item border1px-bottom"
            @click="gotoPage(1, unbill, 'inventory')"
          >
            <span class="item-label">丢宝找回补款</span>
            <span>{{ unbill.assetInventoryAddAmount | formatAmount }}元
              <i class="right-arrow"></i>
            </span>
          </div>
        </div>
      </div>
    </van-list>
    <NoBillTips
      v-else
      msg="暂无未出账单"
    />
    <BannerAd
      :slot-code="SlotCode.BILL_BANNER"
      :cid="cid"
      :mv-bid="$BID.BILL_AD_BANNER_MV"
      :mc-bid="$BID.BILL_AD_BANNER_MC"
    />
  </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';
import List from 'vant/lib/list';
import { getMonth } from '@/util/filter';
import NoBillTips from '@/components/NoBillTips';
import STATUS from '@/constants/status';
import { ACTIVITY_BILL_TYPE } from '@/constants/bill';
import BannerAd from '../../ad/BannerAd';
import { SlotCode } from '@/constants/ad';

export default {
  name: 'UnbilledList',
  components: {
    [List.name]: List,
    NoBillTips,
    BannerAd,
  },
  filters: {
    getMonth,
  },
  data() {
    return {
      unbilledList: [], // 未出账单列表
      loading: false,
      finished: false,
      error: false,
      pageNum: 1,
      pageSize: 10,
      cid: this.$CID.BillList,
      SlotCode,
    };
  },
  created() {
    this.init();
    this.getSlotList([SlotCode.BILL_BANNER]);
  },
  activated() {
    this.getSlotList([SlotCode.BILL_BANNER]);
  },
  methods: {
    ...mapMutations('billModule', ['setCurrentUnbilledInfo']),
    ...mapActions('billModule', ['getBillList']),
    ...mapActions('adModule', ['getSlotList']),

    init() {
      this.pageNum = 1;
      this.finished = false;
      this.unbilledList = [];
      this.getData();
    },
    async getData() {
      const params = {
        billType: 0,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      try {
        const res = await this.getBillList(params) || {};
        if (res.code === STATUS.SUCCESS && res.data) {
          const { isFinished = true, content } = res.data;
          this.unbilledList = this.unbilledList.concat(content || []);
          this.finished = isFinished;
          if (!this.finished) {
            this.pageNum += 1;
          }
        } else {
          this.error = true;
        }
      } catch (e) {
        console.error(e);
        this.error = true;
        this.finished = true;
      } finally {
        this.loading = false;
      }
    },
    gotoPage(type, data, page) {
      this.$route.meta.keepAlive = true;
      this.setCurrentUnbilledInfo(data);
      if (page === 'amortize') {
        this.$router.push({
          name: 'Amortize',
          query: {
            from: 'unbilled',
          },
        });
      } else if (page === 'inventory') {
        this.$router.push({
          name: 'Inventory',
          query: {
            from: 'unbilled',
          },
        });
      } else {
        this.$router.push({
          name: 'MonthBillList',
          query: {
            from: 'unbilled',
            type,
          },
        });
      }
    },
    gotoAgentActivity(data) {
      this.$route.meta.keepAlive = true;
      this.$router.push({
        name: 'AgentActivityBillList',
        query: {
          billType: ACTIVITY_BILL_TYPE.UNBILLED,
          billMonth: data.cutMonth,
          amount: data.agentAgreementBillAmount,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/page/bill.scss";
.bill-container {
  .unbill-container {
    .menu-list {
      margin: 0.18rem 0;
      padding-left: 0;
      .menu-item {
        padding: 20px 26px 20px 0;
        .item-label {
          font-weight: bold;
        }
        .right-arrow {
          right: 0;
        }
      }
    }
  }
}
</style>
